import {
  Fieldset,
  FieldsetLegend,
} from "@imi/ui/components/Fieldset/Fieldset.js";
import { UnitsOptions } from "@src/core/engine/units/unitsRepository";
import { useTranslation } from "react-i18next";
import { useUnitsForm } from "../hooks/useUnitsForm";

type MassAndForceProps = {
  form: ReturnType<typeof useUnitsForm>["form"];
  unitsOptions: UnitsOptions;
};

export function MassAndForce({ form, unitsOptions }: MassAndForceProps) {
  const { t } = useTranslation("settings", { keyPrefix: "units" });

  return (
    <Fieldset>
      <FieldsetLegend>{t("massAndForce.title")}</FieldsetLegend>
      <form.AppField name="mass">
        {(field) => (
          <field.Select label={t("massAndForce.fields.mass")}>
            {unitsOptions.mass.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="force">
        {(field) => (
          <field.Select label={t("massAndForce.fields.force")}>
            {unitsOptions.force.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="torque">
        {(field) => (
          <field.Select label={t("massAndForce.fields.torque")}>
            {unitsOptions.torque.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>
    </Fieldset>
  );
}
